import { FC } from "react";
import Success from "../../../../assets/icon/Success";

const ErrorMessageByVoteModal: FC = () => {
  return (
    <div className="w-full px-8 pb-8">
      <div className="w-full flex flex-col items-center justify-center max-w-[30rem] h-auto text-center">
        <Success />
        <h2 className="py-5 text-xl font-bold" id="modal-title">
          Ваш голос вже зараховано
        </h2>
        <p>За кожну пісню можна голосувати лише один раз.</p>
      </div>
    </div>
  );
};

export default ErrorMessageByVoteModal;
